// Separate fictional trip data; never infer odometers from alcohol readings.
export const seedTrips = []
for (let vehicle = 1; vehicle <= 3; vehicle++) {
  let km = 24000 + vehicle * 10000
  for (let day = 1; day <= 16; day++) {
    const date = `2026-07-${String(day).padStart(2, '0')}`
    if ([0, 6].includes(new Date(`${date}T12:00:00+09:00`).getDay())) continue
    const endKm = km + 45 + (day * 7 + vehicle * 11) % 90
    seedTrips.push({ id: `demo-trip-${vehicle}-${day}`, date, vehicleId: `v0${vehicle}`, driverId: `d0${vehicle}`,
      startedAt: `${date}T08:00:00+09:00`, endedAt: `${date}T17:00:00+09:00`, startKm: km, endKm,
      work: '【サンプル】資材配送・現場への納品', note: '体験用の架空データ', audit: ['体験用サンプル生成'], createdAt: `${date}T08:00:00+09:00` })
    km = endKm
  }
}
